export default __webpack_public_path__ + "static/media/plus.ca25056c.svg";